<template>
  <div class="login-container" :style="loginBackgroundStyle">
    <div class="login-box">
      <div class="login-header">
        <img src="@/assets/logo.jpg" class="login-logo" alt="速飞驰 logo" />
        <h2>极速飞驰管理系统</h2>
        <p>欢迎登录</p>
      </div>

      <form @submit.prevent="handleLogin" class="login-form">
        <div class="form-group">
          <label for="username">账号</label>
          <input id="username" v-model="loginForm.username" type="text" placeholder="请输入账号" required
            class="form-input" />
        </div>

        <div class="form-group">
          <label for="password">密码</label>
          <input id="password" v-model="loginForm.password" type="password" placeholder="请输入密码" required
            class="form-input" />
        </div>

        <div class="form-options">
          <label class="remember-me">
            <input type="checkbox" v-model="rememberMe" />
            <span>记住我</span>
          </label>
          <a href="#" @click.prevent="handleForgotPassword" class="forgot-password">
            忘记密码？
          </a>
        </div>

        <button type="submit" class="login-btn" :disabled="isLoading">
          {{ isLoading ? '登录中...' : '登录' }}
        </button>
      </form>
    </div>

    <!-- 忘记密码模态框 -->
    <div v-if="showForgotPasswordModal" class="modal-overlay" @click="closeForgotPasswordModal">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>忘记密码</h3>
          <button @click="closeForgotPasswordModal" class="close-btn">&times;</button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="handleResetPassword" class="forgot-form">
            <div class="form-group">
              <label for="email" class="required">邮箱地址</label>
              <input id="email" v-model="forgotForm.email" type="email" class="form-input"
                :class="{ 'error': forgotFormErrors.email }" placeholder="请输入邮箱地址" required />
              <span v-if="forgotFormErrors.email" class="error-message">{{ forgotFormErrors.email }}</span>
            </div>

            <div class="form-group">
              <label for="newPassword" class="required">新密码</label>
              <input id="newPassword" v-model="forgotForm.newPassword" type="password" class="form-input"
                :class="{ 'error': forgotFormErrors.newPassword }" placeholder="请输入新密码" required />
              <span v-if="forgotFormErrors.newPassword" class="error-message">{{ forgotFormErrors.newPassword }}</span>
            </div>

            <div class="form-group">
              <label for="captcha" class="required">邮箱验证码</label>
              <div class="captcha-group">
                <input id="captcha" v-model="forgotForm.captcha" type="text" class="form-input captcha-input"
                  :class="{ 'error': forgotFormErrors.captcha }" placeholder="请输入验证码" required />
                <button type="button" @click="sendVerificationCode" :disabled="sendCodeLoading || countdown > 0"
                  class="send-code-btn">
                  {{ countdown > 0 ? `${countdown}s后重发` : '发送验证码' }}
                </button>
              </div>
              <span v-if="forgotFormErrors.captcha" class="error-message">{{ forgotFormErrors.captcha }}</span>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button @click="closeForgotPasswordModal" class="cancel-btn">取消</button>
          <button @click="handleResetPassword" :disabled="resetPasswordLoading" class="submit-btn">
            {{ resetPasswordLoading ? '提交中...' : '提交' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from '../utils/request'

export default {
  name: 'LoginPage',
  data() {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      rememberMe: false,
      isLoading: false,
      showForgotPasswordModal: false,
      forgotForm: {
        email: '',
        newPassword: '',
        captcha: ''
      },
      forgotFormErrors: {},
      sendCodeLoading: false,
      resetPasswordLoading: false,
      countdown: 0
    }
  },
  computed: {
    loginBackgroundStyle() {
      return {
        backgroundImage: `url('${process.env.BASE_URL}5760x1080-45.jpg')`
      }
    }
  },
  methods: {
    async handleLogin() {
      if (!this.loginForm.username || !this.loginForm.password) {
        alert('请输入账号和密码');
        return;
      }

      this.isLoading = true;

      try {
        // 调用后端登录接口
        const response = await request.post('/api/auth/login', {
          username: this.loginForm.username,
          password: this.loginForm.password
        });

        console.log('登录响应:', response.data);

        // 检查响应状态
        if (response.data.success && response.data.code === 200) {
          // 存储用户信息和token
          const userData = response.data.data;
          localStorage.setItem('token', userData.token);
          localStorage.setItem('userInfo', JSON.stringify({
            username: userData.username,
            role: userData.role,
            storeId: userData.storeId,
            realName: userData.realName
          }));

          // 如果选择了记住我，保存用户名
          if (this.rememberMe) {
            localStorage.setItem('rememberedUsername', this.loginForm.username);
          } else {
            localStorage.removeItem('rememberedUsername');
          }

          // 触发登录成功事件，传递用户数据
          this.$emit('login-success', userData);
        } else {
          throw new Error(response.data.message || '登录失败');
        }

      } catch (error) {
        console.error('登录失败:', error);

        let errorMessage = '登录失败，请检查账号密码';

        if (error.response) {
          // 服务器返回了错误响应
          errorMessage = error.response.data.message || `服务器错误: ${error.response.status}`;
        } else if (error.request) {
          // 请求已发出但没有收到响应
          errorMessage = '网络连接失败，请检查网络或服务器状态';
        } else {
          // 其他错误
          errorMessage = error.message || '登录失败，请重试';
        }

        alert(errorMessage);
      } finally {
        this.isLoading = false;
      }
    },

    handleForgotPassword() {
      this.showForgotPasswordModal = true;
      this.resetForgotForm();
    },

    closeForgotPasswordModal() {
      this.showForgotPasswordModal = false;
      this.resetForgotForm();
    },

    resetForgotForm() {
      this.forgotForm = {
        email: '',
        newPassword: '',
        captcha: ''
      };
      this.forgotFormErrors = {};
      this.sendCodeLoading = false;
      this.resetPasswordLoading = false;
      this.countdown = 0;
    },

    validateForgotForm() {
      this.forgotFormErrors = {};
      let isValid = true;

      if (!this.forgotForm.email.trim()) {
        this.forgotFormErrors.email = '请输入邮箱地址';
        isValid = false;
      } else if (!this.isValidEmail(this.forgotForm.email)) {
        this.forgotFormErrors.email = '请输入有效的邮箱地址';
        isValid = false;
      }

      if (!this.forgotForm.newPassword.trim()) {
        this.forgotFormErrors.newPassword = '请输入新密码';
        isValid = false;
      } else if (this.forgotForm.newPassword.length < 6) {
        this.forgotFormErrors.newPassword = '密码长度不能少于6位';
        isValid = false;
      }

      if (!this.forgotForm.captcha.trim()) {
        this.forgotFormErrors.captcha = '请输入验证码';
        isValid = false;
      }

      return isValid;
    },

    isValidEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },

    async sendVerificationCode() {
      if (!this.forgotForm.email.trim()) {
        this.forgotFormErrors.email = '请先输入邮箱地址';
        return;
      }

      if (!this.isValidEmail(this.forgotForm.email)) {
        this.forgotFormErrors.email = '请输入有效的邮箱地址';
        return;
      }

      this.sendCodeLoading = true;
      try {
        const response = await request.post('/api/verification/send', {
          email: this.forgotForm.email,
          type: 'RESET_PASSWORD'
        });

        if (response.data.success && response.data.code === 200) {
          alert('验证码已发送到您的邮箱，请查收');
          this.startCountdown();
        } else {
          throw new Error(response.data.message || '发送验证码失败');
        }
      } catch (error) {
        console.error('发送验证码失败:', error);
        alert(error.message || '发送验证码失败，请重试');
      } finally {
        this.sendCodeLoading = false;
      }
    },

    startCountdown() {
      this.countdown = 60;
      const timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(timer);
        }
      }, 1000);
    },

    async handleResetPassword() {
      if (!this.validateForgotForm()) {
        return;
      }

      this.resetPasswordLoading = true;
      try {
        const response = await request.post('/api/auth/forgot', {
          email: this.forgotForm.email,
          captcha: this.forgotForm.captcha,
          newPassword: this.forgotForm.newPassword
        });

        if (response.data.success && response.data.code === 200) {
          alert('密码重置成功，请使用新密码登录');
          this.closeForgotPasswordModal();
        } else {
          throw new Error(response.data.message || '密码重置失败');
        }
      } catch (error) {
        console.error('密码重置失败:', error);
        alert(error.message || '密码重置失败，请重试');
      } finally {
        this.resetPasswordLoading = false;
      }
    }
  },

  mounted() {
    // 页面加载时检查是否有记住的用户名
    const rememberedUsername = localStorage.getItem('rememberedUsername');
    if (rememberedUsername) {
      this.loginForm.username = rememberedUsername;
      this.rememberMe = true;
    }
  }
}
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  background-color: #0f172a;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  position: relative;
}

.login-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background:
    linear-gradient(135deg, rgba(6, 12, 24, 0.72), rgba(22, 28, 45, 0.48)),
    rgba(0, 0, 0, 0.18);
  z-index: 1;
}

.login-box {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  padding: 40px;
  width: 100%;
  max-width: 400px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 2;
}

.login-header {
  text-align: center;
  margin-bottom: 30px;
}

.login-header h2 {
  color: #333;
  margin: 0 0 8px 0;
  font-size: 24px;
  font-weight: 600;
}

.login-logo {
  width: 100px;
  height: 100px;
  object-fit: contain;
  margin-bottom: 20px;
  border-radius: 50%;
  border: 4px solid white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.login-header p {
  color: #666;
  margin: 0;
  font-size: 14px;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-group label {
  color: #333;
  font-weight: 500;
  font-size: 14px;
}

.form-input {
  padding: 12px 16px;
  border: 2px solid #e1e5e9;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.3s ease;
  background: #fff;
}

.form-input:focus {
  outline: none;
  border-color: #4f46e5;
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
}

.form-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px 0;
}

.remember-me {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #666;
  cursor: pointer;
}

.remember-me input[type="checkbox"] {
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.forgot-password {
  color: #4f46e5;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.3s ease;
}

.forgot-password:hover {
  color: #3730a3;
  text-decoration: underline;
}

.login-btn {
  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
  color: white;
  border: none;
  padding: 14px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 10px;
}

.login-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(79, 70, 229, 0.3);
}

.login-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

/* 响应式设计 */
@media (max-width: 480px) {
  .login-container {
    padding: 10px;
    background-position: 58% center;
  }

  .login-box {
    padding: 30px 20px;
  }

  .login-header h2 {
    font-size: 24px;
  }

  .form-options {
    flex-direction: column;
    gap: 10px;
    align-items: flex-start;
  }
}

/* 忘记密码模态框样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  position: relative;
  z-index: 1001;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #eee;
}

.modal-header h3 {
  margin: 0;
  font-size: 18px;
  color: #333;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-btn:hover {
  color: #333;
}

.modal-body {
  padding: 24px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 20px 24px;
  border-top: 1px solid #eee;
}

.forgot-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.forgot-form .form-group label.required::after {
  content: ' *';
  color: #dc3545;
}

.error-message {
  color: #dc3545;
  font-size: 12px;
  margin-top: 4px;
}

.forgot-form .form-input.error {
  border-color: #dc3545;
}

.captcha-group {
  display: flex;
  gap: 8px;
  align-items: flex-start;
}

.captcha-input {
  flex: 1;
}

.send-code-btn {
  padding: 12px 16px;
  background-color: #4f46e5;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  white-space: nowrap;
}

.send-code-btn:hover:not(:disabled) {
  background-color: #3730a3;
}

.send-code-btn:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}

.cancel-btn,
.submit-btn {
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.cancel-btn {
  background-color: #6c757d;
  color: white;
}

.cancel-btn:hover {
  background-color: #545b62;
}

.submit-btn {
  background-color: #4f46e5;
  color: white;
}

.submit-btn:hover:not(:disabled) {
  background-color: #3730a3;
}

.submit-btn:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}
</style>
